var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"viewBox":"0 0 24 24","aria-hidden":"true","focusable":"false"}},[_c('path',{attrs:{"d":"M4 5a2 2 0 0 1 2-2h11a3 3 0 0 1 3 3v13a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V5Zm3 1v12h10V6H7Zm2 2h6v2H9V8Zm0 4h6v2H9v-2Z"}})])}
var staticRenderFns = []

export { render, staticRenderFns }